import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {};

export default class ExampleComponent extends Component {
  static selector = '[data-comp-example-component]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.helloWorld();
  }

  helloWorld() {
    console.log('Example Component Loaded', { date: new Date() });
  }
}
